import { render, staticRenderFns } from "./ReplyNewParentingArrangements.vue?vue&type=template&id=66c8f2b2"
import script from "./ReplyNewParentingArrangements.vue?vue&type=script&lang=ts"
export * from "./ReplyNewParentingArrangements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports